/*
 * Grippatch - sepetteki kargo ucretini GERCEK tarifeden okur
 *
 * NEDEN VAR: cubuk kargo ucretini tema ayarindan (`kargo_ucreti`) basiyordu.
 * O ayar elle giriliyor; Shopify > Ayarlar > Kargo tarafinda tarife
 * degistiginde ayar geride kaliyor ve musteri sepette bir rakam, odeme
 * adiminda baska bir rakam goruyor. Iki sayiyi elle es tutmak surdurulebilir
 * degil - dogru sayiyi kaynagindan okumak gerekiyor.
 *
 * NASIL: `/cart/shipping_rates.json` yalnizca ULKE ile de cevap veriyor
 * (olculdu 2026-08-25); il/posta kodu sart degil. Yani musteri adres
 * girmeden once bile gercek tarife ogrenilebiliyor.
 *
 * ILERIYE DONUK GELISTIRME: bu dosya calismazsa sunucunun bastigi ayar
 * degeri oldugu gibi kalir - cubuk yine calisir, yalnizca sayi ayardan gelir.
 *
 * NOT: tarife sepet tutarina gore degisebildigi icin onbellek anahtari
 * sepet tutarini icerir. Ayni tutarda ikinci bir istek atilmaz.
 */

(function () {
  'use strict';

  var ONBELLEK = {};

  /* Sunucunun bastigi metnin BICIMI korunuyor, yalnizca SAYI degistiriliyor.
     "136,00 TL" -> "116,00 TL", "$136.00" -> "$116.00". Boylece magazanin
     para bicimi (ayrac, simge, simgenin yeri) neyse oyle kaliyor; burada
     ikinci bir bicim tanimi tutulmuyor ki ikisi ayrisamasin. */
  function sayiyiDegistir(metin, tutar) {
    var virgulOndalik = /\d,\d{2}(\D|$)/.test(metin);
    var yeni = new Intl.NumberFormat(virgulOndalik ? 'tr-TR' : 'en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(tutar);
    var eslesme = metin.match(/[\d][\d.,]*/);
    return eslesme ? metin.replace(eslesme[0], yeni) : yeni;
  }

  function tarifeCek(ulke) {
    return fetch('/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' + encodeURIComponent(ulke), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !Array.isArray(d.shipping_rates) || !d.shipping_rates.length) return null;
        /* Birden fazla tarife varsa musteri en ucuzunu secebilir; cubuk da
           onu soyler. Yoksa "en pahalisi" yazip odeme adiminda daha dusuk
           bir rakam cikar - duzeltmeye calistigimiz sorunun aynisi. */
        return d.shipping_rates.reduce(function (en, r) {
          var f = parseFloat(r.price);
          return en === null || f < en ? f : en;
        }, null);
      })
      .catch(function () { return null; });
  }

  function kur() {
    var kutu = document.querySelector('[data-kbar-ucret]');
    if (!kutu || kutu.dataset.hazir === '1') return;
    kutu.dataset.hazir = '1';

    var ulke = kutu.getAttribute('data-ulke');
    var toplam = kutu.getAttribute('data-sepet') || '0';
    if (!ulke) return; // ulke bilinmiyorsa sunucunun bastigi deger kalsin

    var anahtar = ulke + ':' + toplam;

    var sonuc = anahtar in ONBELLEK
      ? Promise.resolve(ONBELLEK[anahtar])
      : tarifeCek(ulke).then(function (v) { ONBELLEK[anahtar] = v; return v; });

    sonuc.then(function (fiyat) {
      if (fiyat === null) return; // tarife okunamadi - ayar degeri kalsin

      var hedef = kutu.querySelector('[data-kbar-tutar]');
      if (fiyat <= 0) {
        /* Gercek tarife sifirsa "su an kargo ucreti 0" demek yanlis olurdu;
           cumle tamamen kaldiriliyor. */
        kutu.hidden = true;
        return;
      }
      if (hedef) hedef.textContent = sayiyiDegistir(hedef.textContent, fiyat);
      kutu.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }

  /* Sepet degisince theme.js `[data-cart-content]` icerigini yeniden basiyor;
     cubuk da yeniden olusuyor ve `data-hazir` bayragi sifirlaniyor. */
  function izleyiciKur() {
    var hedef = document.querySelector('[data-cart-content]');
    if (!hedef || hedef.dataset.kbarIzleniyor === '1') return;
    hedef.dataset.kbarIzleniyor = '1';
    new MutationObserver(function () { kur(); }).observe(hedef, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', izleyiciKur);
  } else {
    izleyiciKur();
  }

  document.addEventListener('shopify:section:load', function () { kur(); izleyiciKur(); });
})();
